import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from 'serviceWorker';
import { store, loadStateFromStorage } from 'redux/store/configureStore';
import browserHistory from 'router/history';
import { syncHistoryWithStore } from 'react-router-redux';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import App from 'App';

// Keep Redux routing state in sync with the browser history used by <Router>.
const history = syncHistoryWithStore(browserHistory, store);

if (process.env.REACT_APP_ENABLE_SENTRY === 'true') {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY,
        autoSessionTracking: true,
        integrations: [new Integrations.BrowserTracing()],

        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 1.0
    });
}

loadStateFromStorage(store).then(() => {
    ReactDOM.render(
        <Provider store={store}>
            <Router history={history}>
                <App />
            </Router>
        </Provider>,
        document.getElementById('root')
    );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
